import { useTranslation } from "react-i18next";

export default function TaxationServicesSection() {
  const { t } = useTranslation();

  const taxServices = [
    { icon: "ri-file-list-3-line", titleKey: "tax_s1_title", descKey: "tax_s1_desc" },
    { icon: "ri-user-line", titleKey: "tax_s2_title", descKey: "tax_s2_desc" },
    { icon: "ri-home-office-line", titleKey: "tax_s3_title", descKey: "tax_s3_desc" },
    { icon: "ri-shield-check-line", titleKey: "tax_s4_title", descKey: "tax_s4_desc" },
    { icon: "ri-exchange-line", titleKey: "tax_s5_title", descKey: "tax_s5_desc" },
    { icon: "ri-customer-service-2-line", titleKey: "tax_s6_title", descKey: "tax_s6_desc" },
  ];

  return (
    <section id="taxation-services" className="py-24 bg-[#1C2331]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="text-[#F2C4B5] text-sm font-semibold tracking-widest uppercase">{t("tax_tag")}</span>
          <h2 className="text-3xl md:text-4xl font-bold text-white mt-2">{t("tax_heading")}</h2>
          <p className="text-white/55 mt-3 max-w-xl mx-auto text-sm leading-relaxed">
            {t("tax_desc")}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 items-center">
          {/* Service cards */}
          <div className="lg:col-span-3 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {taxServices.map((service) => (
              <div
                key={service.titleKey}
                className="bg-white/5 border border-white/10 hover:border-[#D4927A]/50 hover:bg-white/8 rounded-2xl p-5 transition-all duration-300 group cursor-pointer"
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-[#D4927A]/15 group-hover:bg-[#D4927A] transition-colors mb-3">
                  <i className={`${service.icon} text-lg text-[#F2C4B5] group-hover:text-white transition-colors`} />
                </div>
                <h3 className="font-bold text-white text-sm mb-1.5">{t(service.titleKey)}</h3>
                <p className="text-white/50 text-xs leading-relaxed">{t(service.descKey)}</p>
              </div>
            ))}
          </div>

          {/* Image */}
          <div className="lg:col-span-2 rounded-2xl overflow-hidden h-[420px]">
            <img
              src="https://public.readdy.ai/ai/img_res/88f8c2501dcd4f16d23c4cb4a33020ad.jpg"
              alt="Taxation Services"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>

        {/* CTA strip */}
        <div className="mt-14 bg-gradient-to-r from-[#D4927A]/20 to-[#F2C4B5]/10 border border-[#D4927A]/30 rounded-2xl p-8 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="text-white font-bold text-xl">{t("tax_cta_heading")}</h3>
            <p className="text-white/55 text-sm mt-1">{t("tax_cta_sub")}</p>
          </div>
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="flex items-center gap-2 bg-[#D4927A] hover:bg-[#C07F6A] text-white font-semibold px-7 py-3 rounded-full transition-colors cursor-pointer whitespace-nowrap text-sm"
          >
            {t("tax_cta_btn")} <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}
